import React from 'react'
import { FormattedHTMLMessage, Loader, Spinner } from '@web/walter-ui-kit'

import styles from './style.module.css'
import { useTransactionsList } from '~api'
import PageHeader from '~components/PageLayout/PageHeader'
import { lang as navMenuLang } from '~components/App/Layout/NavigationMenu/lang'
import PageLayout from '~components/PageLayout'

function Preloader() {
    useTransactionsList()

    return (
        <PageLayout
            contentWidth="m"
            header={<PageHeader rootPage title={<FormattedHTMLMessage {...navMenuLang.history} />} />}
        >
            <div data-pointer="history_page_preloader">
                <div className={styles.row}>
                    <Loader borderRadius="s" width={106} height={36} />
                    <Loader borderRadius="s" width={112} height={36} />
                    <Loader borderRadius="s" width={78} height={36} />
                </div>

                <div className={styles.spinner}>
                    <Spinner intent="accent" size={24} />
                </div>
            </div>
        </PageLayout>
    )
}

export default Preloader
